import axios from "axios";
import { AddGoldPayload, CreateDirectOrderPayload, CreateOrderPayload } from "../type";
import { getSdkAuthHeaders } from "./sdk-auth";

export async function createDirectOrder(payload: CreateDirectOrderPayload, apiEndpoint: string, accessToken: string) {
  const response = await axios.post(`${apiEndpoint}/payment/direct-orders`, payload, {
    headers: { Authorization: accessToken }
  });
  return response.data;
}

export async function createOrder(payload: CreateOrderPayload, apiEndpoint: string, accessToken: string) {
  const response = await axios.post(`${apiEndpoint}/payment/h5/orders`, payload, {
    headers: { Authorization: accessToken }
  });
  return response.data;
}

export async function createOrderSDK(payload: CreateOrderPayload, apiEndpoint: string, accessToken: string, productId: string, deviceId: string) {
  const sdkHeaders = getSdkAuthHeaders();
  const response = await axios.post(`${apiEndpoint}/payment/h5/orders`, payload, {
    headers: {
      Authorization: accessToken,
      'X-Product-Id': productId || sdkHeaders['X-Product-Id'] || '',
      'X-Device-Id': deviceId || sdkHeaders['X-Device-Id'] || '',
    }
  });
  return response.data;
}

export async function getProductByCode(productCode: string, apiEndpoint: string) {
  const response = await axios.get(`${apiEndpoint}/products/clientId/${productCode}`);
  return response.data;
}

export async function addGold(payload: AddGoldPayload, apiEndpoint: string, accessToken: string) {
  const response = await axios.post(`${apiEndpoint}/payment/orders/add-gold`, payload, {
    headers: { Authorization: accessToken }
  });
  return response.data;
}

export async function findOrderByRefId(id: string, apiEndpoint: string, accessToken: string) {
  const response = await axios.get(`${apiEndpoint}/orders/${id}`, {
    headers: { Authorization: accessToken, ...getSdkAuthHeaders() }
  });
  return response.data;
}

export async function getSdkPaymentMethods(apiEndpoint: string) {
  const response = await axios.get(`${apiEndpoint}/payment-methods/sdk`);
  return response.data;
}